<!--企业基础档案-->
<div class="sonBody">
  <div class="content contentBG fixTarget" id="content" >
    <div class="rela">
      <div class="Tab1">
        <div class="Tab1Con">
          <div>
            <div class="sonMod1Box padT20B40">
              <div class="w1224 rela">
                <div class="mianbaoDiv">
                  <div class="floatL">您所在的位置：
                    <a *ngIf="fromType == '0'" [routerLink]="['/gzEcommerceSearch']" [queryParams]="{userId: userId, userName: userName}">电商商务诚信</a>
                    <a *ngIf="fromType == '1'" [routerLink]="['/gzLogisticsSearchComponent']" [queryParams]="{userId: userId, userName: userName}">物流商务诚信</a>
                    》企业档案</div>
                  <div class="floatR taRight"><a onclick="history.go(-1);">返回上一页</a></div>
                  <div style="clear: both"></div>
                </div>
                <!--<h2 class="titBlue">
                  <div class="floatL marR40" style="cursor: pointer;">
                    <i></i><span>基础档案</span>
                  </div>
                </h2>-->

                <div id="firstpane" class="menu_list floatL"><!--scl——开头的都是用来做滑动的-->

                  <h3 class="menu_head current "><a class="scl_jcxyzlxx"><span class="menuIcon"><img
                    src="assets/plugins/sfqIE7/images/menuIcon1.png" alt=""/></span><span>基础信用质量信息</span></a></h3>
                  <div style="display:block" class="menu_body">
                    <a class="scl_jbxx active">基本信息</a>
                    <a class="scl_gqlxx">股权类信息</a>
                    <a class="scl_lsyg">历史沿革</a>
                    <a class="scl_zscqxx">知识产权信息</a>
                    <a class="scl_sbxx">商标信息</a>
                    <a class="scl_djgdwrzxx">董监高任职信息</a>
                    <a class="scl_jyzk">经营状况</a>
                  </div>


                  <h3 class="menu_head"><a class="scl_lyjgxx"><span class="menuIcon"><img
                    src="assets/plugins/sfqIE7/images/menuIcon2.png" alt=""/></span><span>履约结果信息</span></a></h3>
                  <div style="display:none" class="menu_body">
                    <a class="scl_dcdy active">动产抵押</a>
                    <a class="scl_gqcz">股权出质</a>
                    <a class="scl_zscqcz">知识产权出质</a>
                    <a class="scl_qsxx">清算信息</a>
                    <a class="scl_gsycml">工商异常名录</a>
                    <a class="scl_sfxx">司法信息</a>
                    <a class="scl_choucha">抽查信息</a>
                    <a class="scl_xzcf">行政处罚信息</a>
                  </div>

                  <h3 class="menu_head"><a class="scl_yqhqtgkxx"><span class="menuIcon"><img
                    src="assets/plugins/sfqIE7/images/menuIcon4.png" alt=""/></span><span>舆情和其他公开信息</span></a></h3>
                  <div style="display:none" class="menu_body">
                    <a class="scl_qyyqxx active">企业舆情信息</a>
                    <a class="scl_ztbxx">招投标信息</a>
                    <a class="scl_zplxx">招聘类信息</a>
                  </div>

                  <div style="height: 50px; line-height: 50px; text-align: center;" *ngIf="companyInfo && showDownloadBtn">
                    <a (click)="creditReportDownload()">
                      <span style="color: #c9071d; font-size: 15px;">
                        信用报告下载&nbsp;&nbsp;<i class="fa fa-download"></i></span>
                    </a>
                  </div>

                </div>

                <div class="archivesBox floatR">
                  <div class="archiveMod">
                    <h3 id="jcxyzlxx" class="jcxyzlxx"><span class="floatL">一、基础信用质量信息</span><span
                      class="floatR"></span>
                    </h3>
                    <h4 id="jbxx" class="jbxx">1.&nbsp;&nbsp;基本信息</h4>
                    <div>
                      <div class="formBoxA">
                        <table cellpadding="0" cellspacing="0" border="0" width="100%" class="mar0A table2">
                          <tr>
                            <th nowrap="nowrap" width="18%">企业名称</th>
                            <td colspan="3" width="*" *ngIf="companyInfo?.name!=null" [innerHTML]="companyInfo?.name | safeHTML"></td>
                            <td colspan="3" width="*" *ngIf="companyInfo?.name==null">-</td>
                          </tr>
                          <tr>
                            <th nowrap="nowrap" width="18%">新华信用码</th>
                            <td width="32%">{{xhCode}}</td>
                            <th nowrap="nowrap" width="18%">统一信用代码/注册号</th>
                            <!-- 统一信用代码/注册号 如果统一信用代码没有，显示注册号 -->
                            <td width="32%" *ngIf="companyInfo?.creditCode!=null && companyInfo?.creditCode!=''">
                              {{companyInfo?.creditCode}}
                            </td>
                            <td width="32%" *ngIf="companyInfo?.creditCode==''|| companyInfo?.creditCode==null">
                              <span *ngIf="companyInfo?.no !=null && companyInfo?.no !=''">{{companyInfo?.no}}</span>
                              <span *ngIf="companyInfo?.no ==null || companyInfo?.no ==''">-</span>
                            </td>
                          </tr>
                          <tr>
                            <th nowrap="nowrap">成立日期</th>
                            <td *ngIf="companyInfo?.startDate!=null">{{companyInfo?.startDate|date:'yyyy-MM-dd'}}</td>
                            <td *ngIf="companyInfo?.startDate==null">-</td>
                            <th nowrap="nowrap">最新登记日期</th>
                            <td *ngIf="companyInfo?.checkDate!=null">{{companyInfo?.checkDate|date:'yyyy-MM-dd'}}</td>
                            <td *ngIf="companyInfo?.checkDate==null">-</td>
                          </tr>
                          <tr>
                            <th nowrap="nowrap">注册资本</th>
                            <td *ngIf="companyInfo?.registCapi!=null">{{companyInfo?.registCapi}}</td>
                            <td *ngIf="companyInfo?.registCapi==null">-</td>
                            <th nowrap="nowrap">法定代表人</th>
                            <td *ngIf="companyInfo?.operName!=null">{{companyInfo?.operName}}</td>
                            <td *ngIf="companyInfo?.operName==null">-</td>

                          </tr>
                          <tr>
                            <th nowrap="nowrap">企业类型</th>
                            <td *ngIf="companyInfo?.econKind!=null">{{companyInfo?.econKind}}</td>
                            <td *ngIf="companyInfo?.econKind==null">-</td>
                            <th nowrap="nowrap">是否为纳税信用A级</th>
                            <td><span class="blue5"><a style="color: #c9071d" *ngIf="companyInfo  && showDownloadBtn"
                                                       (click)="creditReportDownload()">下载报告可见</a></span></td>
                          </tr>
                          <tr>
                            <th nowrap="nowrap">登记状态</th>
                            <td *ngIf="companyInfo?.status!=null">{{companyInfo?.status}}</td>
                            <td *ngIf="companyInfo?.status==null">-</td>
                            <th nowrap="nowrap">登记机关</th>
                            <td *ngIf="companyInfo?.belongOrg!=null">{{companyInfo?.belongOrg}}</td>
                            <td *ngIf="companyInfo?.belongOrg==null">-</td>
                          </tr>
                          <tr>
                            <th nowrap="nowrap">注册地址</th>
                            <td colspan="3" *ngIf="companyInfo?.address!=null">{{companyInfo?.address}}</td>
                            <td colspan="3" *ngIf="companyInfo?.address==null">-</td>
                          </tr>
                          <tr>
                            <th nowrap="nowrap">经营范围</th>
                            <td colspan="3" *ngIf="companyInfo?.scope!=null">{{companyInfo?.scope}}</td>
                            <td colspan="3" *ngIf="companyInfo?.scope==null">-</td>
                          </tr>
                          <tr>
                            <th nowrap="nowrap">企业网站</th>
                            <td colspan="3" *ngIf="companyInfo?.webUrl!=null">
                              <a href="{{'http://'+companyInfo?.webUrl}}" target="_blank" style="color: #c9071d">
                                {{companyInfo?.webUrl}}</a>
                            </td>
                            <td colspan="3" *ngIf="companyInfo?.webUrl==null">-</td>
                          </tr>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div class="archiveMod">
                    <h4 id="gqlxx" class="gqlxx">2.&nbsp;&nbsp;股权类信息</h4>
                    <div>
                      <h5 class="marB20">2.1&nbsp;&nbsp;股东及出资方
                        <span class="totalClass" *ngIf="companyPartnersResult?.totalCount>0">（{{companyPartnersResult?.totalCount}}）</span>
                      </h5>
                      <div class="formBoxA">
                        <table cellpadding="0" cellspacing="0" border="0" width="100%" class="mar0A table2">
                          <tr>
                            <th nowrap="nowrap" width="3%">序号</th>
                            <th nowrap="nowrap" width="*">股东名称</th>
                            <th nowrap="nowrap" width="13%">出资额（万元）</th>
                            <th nowrap="nowrap" width="13%">实缴额（万元）</th>
                            <th nowrap="nowrap" width="13%">比例</th>
                            <th nowrap="nowrap" width="12%">出资形式</th>
                            <th nowrap="nowrap" width="20%">证照号（企业代码/身份证）</th>
                          </tr>
                          <tbody *ngIf="companyPartnersResult?.totalCount>0">
                          <tr *ngFor="let companyPartners of companyPartnersResult?.list;let i = index">
                            <td>{{(companyPartnersResult.page.pageNo-1)*companyPartnersResult.page.pageSize+i+1}}</td>
                            <td *ngIf="companyPartners.stockName!=null && companyPartners.isCompany">
                              <a style="color: #c9071d" (click)="openEnterprise(companyPartners.stockName)">{{companyPartners.stockName}}</a>
                            </td>
                            <td *ngIf="companyPartners.stockName!=null && !companyPartners.isCompany">{{companyPartners.stockName}}</td>
                            <td *ngIf="companyPartners.stockName==null">-</td>
                            <td *ngIf="companyPartners.shouldCapi!=null">{{companyPartners.shouldCapi}}</td>
                            <td *ngIf="companyPartners.shouldCapi==null">-</td>
                            <td *ngIf="companyPartners.realCapi!=null">{{companyPartners.realCapi}}</td>
                            <td *ngIf="companyPartners.realCapi==null">-</td>
                            <td *ngIf="companyPartners.stockPercent!=null">{{companyPartners.stockPercent}}</td>
                            <td *ngIf="companyPartners.stockPercent==null">-</td>
                            <td *ngIf="companyPartners.investName!=null">{{companyPartners.investName}}</td>
                            <td *ngIf="companyPartners.investName==null">-</td>
                            <td *ngIf="companyPartners.identifyNo!=null">{{companyPartners.identifyNo}}</td>
                            <td *ngIf="companyPartners.identifyNo==null">-</td>
                          </tr>
                          </tbody>
                          <tbody *ngIf="companyPartnersResult?.totalCount<1">
                          <tr>
                            <td colspan="7" style="text-align: center">暂无信息</td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                      <div [hidden]="companyPartnersResult?.totalCount<10">
                        <app-page [totals]="companyPartnersResult?.totalCount"
                                  [pageId]="'companyPartnersId'"></app-page>
                      </div>
                    </div>
                  </div>

                  <div class="archiveMod">
                    <div>
                      <h5 class="marB20">2.2&nbsp;&nbsp;对外投资
                        <span class="totalClass" *ngIf="investInfoResult?.totalCount>0">（{{investInfoResult?.totalCount}}）</span>
                      </h5>
                      <div class="formBoxA">
                        <table cellpadding="0" cellspacing="0" border="0" width="100%" class=" mar0A table2">
                          <tr>
                            <th nowrap="nowrap" width="3%">序号</th>
                            <th nowrap="nowrap" width="*">被投资企业名称</th>
                            <th nowrap="nowrap" width="24%">注册资本（万元）</th>
                            <th nowrap="nowrap" width="14%">出资比例</th>
                            <th nowrap="nowrap" width="25%">社会统一信用代码（工商）</th>
                          </tr>

                          <tr *ngFor="let investInfo of investInfoResult?.list;let i = index">
                            <td>{{(investInfoResult.page.pageNo-1)*investInfoResult.page.pageSize+i+1}}</td>
                            <td *ngIf="investInfo.name!=null"><a style="color: #c9071d" (click)="openEnterprise(investInfo.name)">{{investInfo.name}}</a>
                            </td>
                            <td *ngIf="investInfo.name==null">-</td>
                            <td *ngIf="investInfo.registCapi!=null">{{investInfo.registCapi}}</td>
                            <td *ngIf="investInfo.registCapi==null">-</td>
                            <td style="color: red"><a style="color: #c9071d" *ngIf="showDownloadBtn"
                                                      (click)="creditReportDownload()">下载报告可见</a>
                            </td>
                            <td *ngIf="investInfo.no!=null">{{investInfo.no}}</td>
                            <td *ngIf="investInfo.no==null">-</td>
                          </tr>
                          <tbody *ngIf="investInfoResult?.totalCount<1">
                          <tr>
                            <td colspan="5" style="text-align: center">暂无信息</td>
                          </tr>
                          </tbody>
                        </table>
                        <div [hidden]="investInfoResult?.totalCount<10">
                          <app-page [totals]="investInfoResult?.totalCount" [pageId]="'investInfoId'"></app-page>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="archiveMod">
                    <div>
                      <h5 class="marB20">2.3&nbsp;&nbsp;分支机构
                        <span class="totalClass"
                              *ngIf="branchResult?.totalCount>0">（{{branchResult?.totalCount}}）</span></h5>
                      <div class="formBoxA">
                        <table cellpadding="0" cellspacing="0" border="0" width="100%" class="mar0A table2">
                          <tr>
                            <th nowrap="nowrap" width="3%">序号</th>
                            <th nowrap="nowrap" width="*">分支机构名称</th>
                            <th nowrap="nowrap" width="10%">负责人</th>
                            <th nowrap="nowrap" width="23%">社会统一信用代码（工商）</th>
                            <th nowrap="nowrap" width="26%">注册机关</th>
                          </tr>
                          <tr *ngFor="let branch of branchResult?.list;let i = index">
                            <td>{{(branchResult.page.pageNo-1)*branchResult.page.pageSize+i+1}}</td>
                            <td *ngIf="branch.name!=null && branch.isCompany">
                              <a style="color: #c9071d" (click)="openEnterprise(branch.name)">{{branch.name}}</a>
                            </td>
                            <td *ngIf="branch.name!=null && !branch.isCompany">
                              {{branch.name}}
                            </td>
                            <td *ngIf="branch.name==null">-</td>
                            <td *ngIf="branch.operName!=null">{{branch.operName}}</td>
                            <td *ngIf="branch.operName==null">-</td>
                            <td *ngIf="branch.creditCode!=null">{{branch.creditCode}}</td>
                            <td *ngIf="branch.creditCode==null">-</td>
                            <td *ngIf="branch.belongOrg!=null">{{branch.belongOrg}}</td>
                            <td *ngIf="branch.belongOrg==null">-</td>
                          </tr>
                          <tbody *ngIf="branchResult?.totalCount<1">
                          <tr>
                            <td colspan="7" style="text-align: center">暂无信息</td>
                          </tr>
                          </tbody>
                        </table>
                        <div [hidden]="branchResult?.totalCount<10">
                          <app-page [totals]="branchResult?.totalCount" [pageId]="'branchId'"></app-page>
                        </div>
                      </div>
                    </div>
                  </div>


                  <div class="archiveMod">
                    <h4 id="lsyg" class="lsyg">3.&nbsp;&nbsp;历史沿革</h4>
                    <div>
                      <h5 class="marB20">3.1&nbsp;&nbsp;工商变更记录
                        <span class="totalClass"
                              *ngIf="changeResult?.totalCount>0">（{{changeResult?.totalCount}}）</span></h5>
                      <div class="formBoxA">
                        <table cellpadding="0" cellspacing="0" border="0" width="100%" class=" mar0A table2">
                          <tr>
                            <th width="3%">序号</th>
                            <th width="*">变更事项</th>
                            <th width="33%">变更前内容</th>
                            <th width="33%">变更后内容</th>
                            <th width="13%">变更日期</th>
                          </tr>
                          <tr *ngFor="let change of changeResult?.list;let i = index">
                            <td>{{(changeResult.page.pageNo-1)*changeResult.page.pageSize+i+1}}</td>
                            <td *ngIf="change.projectName!=null">{{change.projectName}}</td>
                            <td *ngIf="change.projectName==null">-</td>
                            <td *ngIf="change.beforeContent!=null" [innerHTML]="change.beforeContent | safeHTML"></td>
                            <td *ngIf="change.beforeContent==null">-</td>
                            <td *ngIf="change.afterContent!=null" [innerHTML]="change.afterContent | safeHTML"></td>
                            <td *ngIf="change.afterContent==null">-</td>
                            <td *ngIf="change.changeDate!=null">{{change.changeDate|date:'yyyy-MM-dd'}}</td>
                            <td *ngIf="change.changeDate==null">-</td>
                          </tr>
                          <tbody *ngIf="changeResult?.totalCount<1">
                          <tr>
                            <td colspan="5" style="text-align: center">暂无信息</td>
                          </tr>
                          </tbody>
                        </table>
                        <div [hidden]="changeResult?.totalCount<10">
                          <app-page [totals]="changeResult?.totalCount" [pageId]="'changeId'"></app-page>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="archiveMod">
                    <h5 class="marB20">3.2&nbsp;&nbsp;经营范围变更
                      <span class="totalClass" *ngIf="scopeChangeResult?.totalCount>0">（{{scopeChangeResult?.totalCount}}）</span>
                    </h5>
                    <div>
                      <div class="formBoxA">
                        <table cellpadding="0" cellspacing="0" border="0" width="100%" class="mar0A table2">
                          <tr>
                            <th nowrap="nowrap" width="3%">序号</th>
                            <th nowrap="nowrap" width="40%">变更前内容</th>
                            <th nowrap="nowrap" width="40%">变更后内容</th>
                            <th nowrap="nowrap" width="13%">变更日期</th>
                          </tr>

                          <tr *ngFor="let scopeChange of scopeChangeResult?.list;let i = index">
                            <td>{{(scopeChangeResult.page.pageNo-1)*scopeChangeResult.page.pageSize+i+1}}</td>
                            <td *ngIf="scopeChange.beforeContent!=null"
                                [innerHTML]="scopeChange.beforeContent | safeHTML"></td>
                            <td *ngIf="scopeChange.beforeContent==null">-</td>
                            <td *ngIf="scopeChange.afterContent!=null"
                                [innerHTML]="scopeChange.afterContent | safeHTML"></td>
                            <td *ngIf="scopeChange.afterContent==null">-</td>
                            <td *ngIf="scopeChange.changeDate!=null">{{scopeChange.changeDate|date:'yyyy-MM-dd'}}</td>
                            <td *ngIf="scopeChange.changeDate==null">-</td>
                          </tr>
                          <tbody *ngIf="scopeChangeResult?.totalCount<1">
                          <tr>
                            <td colspan="4" style="text-align: center">暂无信息</td>
                          </tr>
                          </tbody>
                        </table>
                        <div [hidden]="scopeChangeResult?.totalCount<10">
                          <app-page [totals]="scopeChangeResult?.totalCount" [pageId]="'scopeChangeId'"></app-page>
                        </div>
                      </div>
                    </div>
                  </div>


                  <div class="archiveMod">
                    <h4 id="zscqxx" class="zscqxx">4.&nbsp;&nbsp;知识产权信息</h4>
                    <div>
                      <h5 class="marB20">4.1&nbsp;&nbsp;专利信息
                        <span class="totalClass" *ngIf="patentDetailResult?.totalCount>0">（{{patentDetailResult?.totalCount}}）</span>
                      </h5>
                      <div class="formBoxA">
                        <table cellpadding="0" cellspacing="0" border="0" width="100%" class=" mar0A table2">
                          <tr>
                            <th nowrap="nowrap" width="3%">序号</th>
                            <th nowrap="nowrap" width="*">专利名称</th>
                            <th nowrap="nowrap" width="23%">公示号</th>
                            <th nowrap="nowrap" width="18%">专利类型</th>
                            <th nowrap="nowrap" width="14%">公开日期</th>
                          </tr>
                          <tr *ngFor="let patentDetai of patentDetailResult?.list;let i = index">
                            <td>{{(patentDetailResult.page.pageNo-1)*patentDetailResult.page.pageSize+i+1}}</td>
                            <td *ngIf="patentDetai.title!=null">{{patentDetai.title}}</td>
                            <td *ngIf="patentDetai.title==null">-</td>
                            <td *ngIf="patentDetai.publicationNumber!=null">{{patentDetai.publicationNumber}}</td>
                            <td *ngIf="patentDetai.publicationNumber==null">-</td>
                            <td *ngIf="patentDetai.kindCodeDesc!=null">{{patentDetai.kindCodeDesc}}</td>
                            <td *ngIf="patentDetai.kindCodeDesc==null">-</td>
                            <td *ngIf="patentDetai.pubDate!=null">{{patentDetai.pubDate|date:'yyyy-MM-dd'}}</td>
                            <td *ngIf="patentDetai.pubDate==null">-</td>
                          </tr>
                          <tbody *ngIf="patentDetailResult?.totalCount<1">
                          <tr>
                            <td colspan="5" style="text-align: center">暂无信息</td>
                          </tr>
                          </tbody>
                        </table>
                        <div [hidden]="patentDetailResult?.totalCount<10">
                          <app-page [totals]="patentDetailResult?.totalCount" [pageId]="'patentDetailId'"></app-page>
                        </div>
                      </div>
                    </div>


                    <div>
                      <h5 class="marB20">4.2&nbsp;&nbsp;软件著作权信息
                        <span class="totalClass" *ngIf="softwareCopyrightsResult?.totalCount>0">（{{softwareCopyrightsResult?.totalCount}}）</span>
                      </h5>
                      <div class="formBoxA">
                        <table cellpadding="0" cellspacing="0" border="0" width="100%" class="mar0A table2">
                          <tr>
                            <th nowrap="nowrap" width="3%">序号</th>
                            <th nowrap="nowrap" width="*">名称</th>
                            <th nowrap="nowrap" width="12%">登记号</th>
                            <th nowrap="nowrap" width="20%">著作权人</th>
                            <th nowrap="nowrap" width="12%">登记日期</th>
                            <th nowrap="nowrap" width="9%">作品类型</th>
                            <th nowrap="nowrap" width="12%">发布日期</th>
                          </tr>
                          <tr *ngFor="let softwareCopyrights of softwareCopyrightsResult?.list;let i = index">
                            <td>
                              {{(softwareCopyrightsResult.page.pageNo-1)*softwareCopyrightsResult.page.pageSize+i+1}}
                            </td>
                            <td *ngIf="softwareCopyrights.name!=null">{{softwareCopyrights.name}}</td>
                            <td *ngIf="softwareCopyrights.name==null">-</td>
                            <td *ngIf="softwareCopyrights.registerNo!=null">{{softwareCopyrights.registerNo}}</td>
                            <td *ngIf="softwareCopyrights.registerNo==null">-</td>
                            <td *ngIf="softwareCopyrights.companyName!=null">{{softwareCopyrights.companyName}}</td>
                            <td *ngIf="softwareCopyrights.companyName==null">-</td>
                            <td *ngIf="softwareCopyrights.registerAperDate!=null">
                              {{softwareCopyrights.registerAperDate|date:'yyyy-MM-dd'}}
                            </td>
                            <td *ngIf="softwareCopyrights.registerAperDate==null">-</td>
                            <td *ngIf="softwareCopyrights.category!=null">{{softwareCopyrights.category}}</td>
                            <td *ngIf="softwareCopyrights.category==null">-</td>
                            <!--过滤1900-01-01日期的数据，需要时打开-->
                            <!--<td *ngIf="softwareCopyrights.publishDate!=null&&(softwareCopyrights.publishDate!='1900-01-01 00:00:01'&&softwareCopyrights.publishDate!='1900-01-01 00:00:00') ">{{softwareCopyrights.publishDate | date: 'yyyy-MM-dd'}}</td>-->
                            <!--<td *ngIf="softwareCopyrights.publishDate!=null&&(softwareCopyrights.publishDate=='1900-01-01 00:00:01'||softwareCopyrights.publishDate=='1900-01-01 00:00:00')">-</td>-->
                            <td *ngIf="softwareCopyrights.publishDate!=null">{{softwareCopyrights.publishDate | date:
                              'yyyy-MM-dd'}}
                            </td>
                            <td *ngIf="softwareCopyrights.publishDate==null">-</td>
                          </tr>
                          <tbody *ngIf="softwareCopyrightsResult?.totalCount<1">
                          <tr>
                            <td colspan="7" style="text-align: center">暂无信息</td>
                          </tr>
                          </tbody>
                        </table>
                        <div [hidden]="softwareCopyrightsResult?.totalCount<10">
                          <app-page [totals]="softwareCopyrightsResult?.totalCount"
                                    [pageId]="'softwareCopyrightsId'"></app-page>
                        </div>
                      </div>
                    </div>

                    <div>
                      <h5 class="marB20">4.3&nbsp;&nbsp;作品著作权信息
                        <span class="totalClass"
                              *ngIf="copyrightResult?.totalCount>0">（{{copyrightResult?.totalCount}}）</span></h5>
                      <div class="formBoxA">
                        <table cellpadding="0" cellspacing="0" border="0" width="100%" class="mar0A table2">
                          <tr>
                            <th nowrap="nowrap" width="3%">序号</th>
                            <th nowrap="nowrap" width="*">名称</th>
                            <th nowrap="nowrap" width="15%">登记号</th>
                            <th nowrap="nowrap" width="20%">著作权人</th>
                            <th nowrap="nowrap" width="12%">登记日期</th>
                            <th nowrap="nowrap" width="10%">作品类型</th>
                            <th nowrap="nowrap" width="12%">发布日期</th>
                          </tr>
                          <tr *ngFor="let copyright of copyrightResult?.list;let i = index">
                            <td>{{(copyrightResult.page.pageNo-1)*copyrightResult.page.pageSize+i+1}}</td>
                            <td *ngIf="copyright.name!=null">{{copyright.name}}</td>
                            <td *ngIf="copyright.name==null">-</td>
                            <td *ngIf="copyright.registerNo!=null">{{copyright.registerNo}}</td>
                            <td *ngIf="copyright.registerNo==null">-</td>
                            <td *ngIf="copyright.owner!=null">{{copyright.owner}}</td>
                            <td *ngIf="copyright.owner==null">-</td>
                            <td *ngIf="copyright.registerDate!=null">{{copyright.registerDate|date:'yyyy-MM-dd'}}</td>
                            <td *ngIf="copyright.registerDate==null">-</td>
                            <td *ngIf="copyright.category!=null">{{copyright.category}}</td>
                            <td *ngIf="copyright.category==null">-</td>
                            <td *ngIf="copyright.publishDate!=null">{{copyright.publishDate | date: 'yyyy-MM-dd'}}</td>
                            <td *ngIf="copyright.publishDate==null">-</td>
                          </tr>
                          <tbody *ngIf="copyrightResult?.totalCount<1">
                          <tr>
                            <td colspan="7" style="text-align: center">暂无信息</td>
                          </tr>
                          </tbody>
                        </table>
                        <div [hidden]="copyrightResult?.totalCount<10">
                          <app-page [totals]="copyrightResult?.totalCount" [pageId]="'copyrightId'"></app-page>
                        </div>
                      </div>
                    </div>

                    <div>
                      <h5 class="marB20">4.4&nbsp;&nbsp;网站信息
                        <span class="totalClass"
                              *ngIf="websiteResult?.totalCount>0">（{{websiteResult?.totalCount}}）</span></h5>
                      <div class="formBoxA">
                        <table cellpadding="0" cellspacing="0" border="0" width="100%" class="mar0A table2">
                          <tr>
                            <th nowrap="nowrap" width="3%">序号</th>
                            <th nowrap="nowrap" width="*">网址</th>
                            <th nowrap="nowrap" width="15%">网站类别</th>
                            <th nowrap="nowrap" width="20%">域名</th>
                            <th nowrap="nowrap" width="20%">网站备案/许可证号</th>
                            <th nowrap="nowrap" width="15%">审核时间</th>
                          </tr>
                          <tr *ngFor="let website of websiteResult?.list;let i = index">
                            <td>{{(websiteResult.page.pageNo-1)*websiteResult.page.pageSize+i+1}}</td>
                            <td *ngIf="website.homeSite!=null">{{website.homeSite}}</td>
                            <td *ngIf="website.homeSite==null">-</td>
                            <td *ngIf="website.typeName!=null">{{website.typeName}}</td>
                            <td *ngIf="website.typeName==null">-</td>
                            <td *ngIf="website.yuMing!=null">{{website.yuMing}}</td>
                            <td *ngIf="website.yuMing==null">-</td>
                            <td *ngIf="website.beiAn!=null">{{website.beiAn}}</td>
                            <td *ngIf="website.beiAn==null">-</td>
                            <td *ngIf="website.sDate!=null">{{website.sDate|date:'yyyy-MM-dd'}}</td>
                            <td *ngIf="website.sDate==null">-</td>
                          </tr>
                          <tbody *ngIf="websiteResult?.totalCount<1">
                          <tr>
                            <td colspan="7" style="text-align: center">暂无信息</td>
                          </tr>
                          </tbody>
                        </table>
                        <div [hidden]="websiteResult?.totalCount<10">
                          <app-page [totals]="websiteResult?.totalCount" [pageId]="'websiteId'"></app-page>
                        </div>
                      </div>
                    </div>

                    <div>
                      <h5 class="marB20">4.5&nbsp;&nbsp;证书信息
                        <span class="totalClass" *ngIf="certificationResult?.totalCount>0">（{{certificationResult?.totalCount}}）</span>
                      </h5>
                      <div class="formBoxA">
                        <table cellpadding="0" cellspacing="0" border="0" width="100%" class="mar0A table2">
                          <tr>
                            <th nowrap="nowrap" width="3%">序号</th>
                            <th nowrap="nowrap" width="*">证书名称</th>
                            <th nowrap="nowrap" width="25%">证书编号</th>
                            <th nowrap="nowrap" width="15%">发证日期</th>
                            <th nowrap="nowrap" width="15%">证书状态</th>
                          </tr>
                          <tr *ngFor="let certification of certificationResult?.list;let i = index">
                            <td>{{(certificationResult.page.pageNo-1)*certificationResult.page.pageSize+i+1}}</td>
                            <td *ngIf="certification.name!=null">{{certification.name}}</td>
                            <td *ngIf="certification.name==null">-</td>
                            <td *ngIf="certification.certificateNumber!=null">{{certification.certificateNumber}}</td>
                            <td *ngIf="certification.certificateNumber==null">-</td>
                            <td *ngIf="certification.startDate!=null">{{certification.startDate|date:'yyyy-MM-dd'}}</td>
                            <td *ngIf="certification.startDate==null">-</td>
                            <td *ngIf="certification.currentState!=null">{{certification.currentState}}</td>
                            <td *ngIf="certification.currentState==null">-</td>
                          </tr>
                          <tbody *ngIf="certificationResult?.totalCount<1">
                          <tr>
                            <td colspan="7" style="text-align: center">暂无信息</td>
                          </tr>
                          </tbody>
                        </table>
                        <div [hidden]="certificationResult?.totalCount<10">
                          <app-page [totals]="certificationResult?.totalCount" [pageId]="'certificationId'"></app-page>
                        </div>
                      </div>
                    </div>

                  </div>


                  <div class="archiveMod">
                    <h4 id="sbxx" class="sbxx">5.&nbsp;&nbsp;商标信息
                      <span class="totalClass" *ngIf="tmInfoResult?.totalCount>0">（{{tmInfoResult?.totalCount}}）</span>
                    </h4>
                    <div>
                      <div class="formBoxA">
                        <table cellpadding="0" cellspacing="0" border="0" width="100%" class="mar0A table2">
                          <tr>
                            <th nowrap="nowrap" width="3%">序号</th>
                            <th nowrap="nowrap" width="12%">商标名称</th>
                            <th nowrap="nowrap" width="130">商标图案</th>
                            <th nowrap="nowrap" width="12%">申请/注册号</th>
                            <th nowrap="nowrap" width="15%">申请日期</th>
                            <th nowrap="nowrap" width="*">申请人名称</th>
                            <th nowrap="nowrap" width="15%">商标类型</th>
                            <th nowrap="nowrap" width="12%">商标状态</th>
                          </tr>
                          <tr *ngFor="let tmInfo of tmInfoResult?.list;let i = index">
                            <td>{{(tmInfoResult.page.pageNo-1)*tmInfoResult.page.pageSize+i+1}}</td>
                            <td *ngIf="tmInfo.name!=null">{{tmInfo.name}}</td>
                            <td *ngIf="tmInfo.name==null">-</td>
                            <td *ngIf="tmInfo.imageUrl!=null"><img src="{{tmInfo.imageUrl}}"
                                                                   style="max-height: 60px; max-width: 100px;"></td>
                            <td *ngIf="tmInfo.imageUrl==null">-</td>
                            <td *ngIf="tmInfo.regno!=null">{{tmInfo.regno}}</td>
                            <td *ngIf="tmInfo.regno==null">-</td>
                            <td *ngIf="tmInfo.appDate!=null">{{tmInfo.appDate|date:'yyyy-MM-dd'}}</td>
                            <td *ngIf="tmInfo.appDate==null">-</td>
                            <td *ngIf="tmInfo.applicantCn!=null">{{tmInfo.applicantCn}}</td>
                            <td *ngIf="tmInfo.applicantCn==null">-</td>
                            <td *ngIf="tmInfo.intClsDesc!=null">{{tmInfo.intClsDesc}}</td>
                            <td *ngIf="tmInfo.intClsDesc==null">-</td>
                            <td *ngIf="tmInfo.status==1">有效</td>
                            <td *ngIf="tmInfo.status==2">无效</td>
                            <td *ngIf="tmInfo.status==3">待审</td>
                            <td *ngIf="tmInfo.status==4">不定</td>
                            <td *ngIf="tmInfo.status==5">未知状态</td>
                            <td *ngIf="tmInfo.status==null">-</td>
                          </tr>
                          <tbody *ngIf="tmInfoResult?.totalCount<1">
                          <tr>
                            <td colspan="8" style="text-align: center">暂无信息</td>
                          </tr>
                          </tbody>
                        </table>
                        <div [hidden]="tmInfoResult?.totalCount<10">
                          <app-page [totals]="tmInfoResult?.totalCount" [pageId]="'tmInfoId'"></app-page>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="archiveMod">
                    <h4 id="djgdwrzxx" class="djgdwrzxx">6.&nbsp;&nbsp;董监高任职信息</h4>
                    <div>
                      <span class="blue5">（仅在下载报告中显示）</span>
                    </div>
                  </div>

                  <div class="archiveMod">
                    <h4 id="jyzk" class="jyzk">7.&nbsp;&nbsp;经营状况</h4>
                    <div>
                      <h5 class="marB20">7.1&nbsp;&nbsp;融资信息
                        <span class="totalClass"
                              *ngIf="financingResult?.totalCount>0">（{{financingResult?.totalCount}}）</span></h5>
                      <div class="formBoxA">
                        <table cellpadding="0" cellspacing="0" border="0" width="100%" class=" mar0A table2">
                          <tr>
                            <th nowrap="nowrap" width="3%">序号</th>
                            <th nowrap="nowrap" width="15%">日期</th>
                            <th nowrap="nowrap" width="*">投资方</th>
                            <th nowrap="nowrap" width="15%">级别</th>
                            <th nowrap="nowrap" width="15%">金额</th>
                          </tr>
                          <tr *ngFor="let financing of financingResult?.list;let i = index">
                            <td>{{(financingResult.page.pageNo-1)*financingResult.page.pageSize+i+1}}</td>
                            <td *ngIf="financing.date!=null">{{financing.date|date:'yyyy-MM-dd'}}</td>
                            <td *ngIf="financing.date==null">-</td>
                            <td *ngIf="financing.investment!=null">{{financing.investment}}</td>
                            <td *ngIf="financing.investment==null">-</td>
                            <td *ngIf="financing.round!=null">{{financing.round}}</td>
                            <td *ngIf="financing.round==null">-</td>
                            <td *ngIf="financing.amount!=null">{{financing.amount}}</td>
                            <td *ngIf="financing.amount==null">-</td>
                          </tr>
                          <tbody *ngIf="financingResult?.totalCount<1">
                          <tr>
                            <td colspan="5" style="text-align: center">暂无信息</td>
                          </tr>
                          </tbody>
                        </table>
                        <div [hidden]="financingResult?.totalCount<10">
                          <app-page [totals]="financingResult?.totalCount" [pageId]="'financingId'"></app-page>
                        </div>
                      </div>
                    </div>


                    <div>
                      <h5 class="marB20">7.2&nbsp;&nbsp;财务总览信息
                        <span class="totalClass" *ngIf="financingTaxResult?.totalCount>0">（{{financingTaxResult?.totalCount}}）</span>
                      </h5>
                      <div class="formBoxA">
                        <table cellpadding="0" cellspacing="0" border="0" width="100%" class="mar0A table2">
                          <tr>
                            <th nowrap="nowrap" width="3%">序号</th>
                            <th nowrap="nowrap" width="*">公司实力等级(元)</th>
                            <th nowrap="nowrap" width="26%">纳税区间(元)</th>
                            <th nowrap="nowrap" width="15%">销售净利润率</th>
                            <th nowrap="nowrap" width="15%">销售毛利率</th>
                            <th nowrap="nowrap" width="10%">财务年度</th>
                          </tr>
                          <tr *ngFor="let financingTax of financingTaxResult?.list;let i = index">
                            <td>{{(financingTaxResult.page.pageNo-1)*financingTaxResult.page.pageSize+i+1}}</td>
                            <td *ngIf="financingTax.revenueRange!=null">{{financingTax.revenueRange}}</td>
                            <td *ngIf="financingTax.revenueRange==null">-</td>
                            <td *ngIf="financingTax.taxRange!=null">{{financingTax.taxRange}}</td>
                            <td *ngIf="financingTax.taxRange==null">-</td>
                            <td *ngIf="financingTax.netProfitMargins!=null">{{financingTax.netProfitMargins}}</td>
                            <td *ngIf="financingTax.netProfitMargins==null">-</td>
                            <td *ngIf="financingTax.grossProfitMargins!=null">{{financingTax.grossProfitMargins}}</td>
                            <td *ngIf="financingTax.grossProfitMargins==null">-</td>
                            <td *ngIf="financingTax.year!=null">{{financingTax.year}}</td>
                            <td *ngIf="financingTax.year==null">-</td>
                          </tr>
                          <tbody *ngIf="financingTaxResult?.totalCount<1">
                          <tr>
                            <td colspan="7" style="text-align: center">暂无信息</td>
                          </tr>
                          </tbody>
                        </table>
                        <div [hidden]="financingTaxResult?.totalCount<10">
                          <app-page [totals]="financingTaxResult?.totalCount" [pageId]="'financingTaxId'"></app-page>
                        </div>
                      </div>
                    </div>

                    <div>
                      <h5 class="marB20">7.3&nbsp;&nbsp;产品信息
                        <span class="totalClass"
                              *ngIf="productResult?.totalCount>0">（{{productResult?.totalCount}}）</span></h5>
                      <div class="formBoxA">
                        <table cellpadding="0" cellspacing="0" border="0" width="100%" class="mar0A table2">
                          <tr>
                            <th nowrap="nowrap" width="3%">序号</th>
                            <th nowrap="nowrap" width="130">产品图片</th>
                            <th nowrap="nowrap" width="12%">产品名</th>
                            <th nowrap="nowrap" width="15%">所属领域</th>
                            <th nowrap="nowrap" width="*">产品介绍</th>
                            <th nowrap="nowrap" width="12%">网址</th>
                          </tr>
                          <tr *ngFor="let product of productResult?.list;let i = index">
                            <td>{{(productResult.page.pageNo-1)*productResult.page.pageSize+i+1}}</td>
                            <td *ngIf="product.imageUrl!=null"><img src="{{product.imageUrl}}"
                                                                    style="max-height: 60px; max-width: 100px;"></td>
                            <td *ngIf="product.imageUrl==null">-</td>
                            <td *ngIf="product.name!=null">{{product.name}}</td>
                            <td *ngIf="product.name==null">-</td>
                            <td *ngIf="product.domainDesc!=null">{{product.domainDesc}}</td>
                            <td *ngIf="product.domainDesc==null">-</td>
                            <td *ngIf="product.description!=null">{{product.description}}</td>
                            <td *ngIf="product.description==null">-</td>
                            <td *ngIf="product.link!=null">{{product.link}}</td>
                            <td *ngIf="product.link==null">-</td>
                          </tr>
                          <tbody *ngIf="productResult?.totalCount<1">
                          <tr>
                            <td colspan="7" style="text-align: center">暂无信息</td>
                          </tr>
                          </tbody>
                        </table>
                        <div [hidden]="productResult?.totalCount<10">
                          <app-page [totals]="productResult?.totalCount" [pageId]="'productId'"></app-page>
                        </div>
                      </div>
                    </div>

                  </div>

                  <div class="archiveMod">
                    <h3 id="lyjgxx" class="lyjgxx"><span class="floatL">二、履约结果信息</span><span class="floatR"></span></h3>
                    <h4 id="dcdy" class="dcdy">1.&nbsp;&nbsp;动产抵押
                      <span class="totalClass"
                            *ngIf="mPledgeResult?.totalCount>0">（{{mPledgeResult?.totalCount}}）</span></h4>
                    <div>
                      <div class="formBoxA">
                        <table cellpadding="0" cellspacing="0" border="0" width="100%" class="mar0A table2">
                          <tr>
                            <th nowrap="nowrap" width="3%">序号</th>
                            <th nowrap="nowrap" width="20%">登记编号</th>
                            <th nowrap="nowrap" width="12%">登记日期</th>
                            <th nowrap="nowrap" width="*">登记机关</th>
                            <th nowrap="nowrap" width="13%">被担保债权数额</th>
                            <th nowrap="nowrap" width="7%">状态</th>
                            <th nowrap="nowrap" width="15%">公示日期</th>
                          </tr>
                          <tr *ngFor="let mPledge of mPledgeResult?.list;let i = index">
                            <td>{{(mPledgeResult.page.pageNo-1)*mPledgeResult.page.pageSize+i+1}}</td>
                            <td *ngIf="mPledge.registerNo!=null">{{mPledge.registerNo}}</td>
                            <td *ngIf="mPledge.registerNo==null">-</td>
                            <td *ngIf="mPledge.registerDate!=null">{{mPledge.registerDate|date:'yyyy-MM-dd'}}</td>
                            <td *ngIf="mPledge.registerDate==null">-</td>
                            <td *ngIf="mPledge.registerOffice!=null">{{mPledge.registerOffice}}</td>
                            <td *ngIf="mPledge.registerOffice==null">-</td>
                            <td *ngIf="mPledge.debt_securedAmount!=null">{{mPledge.debt_securedAmount}}</td>
                            <td *ngIf="mPledge.debt_securedAmount==null">-</td>
                            <td *ngIf="mPledge.status!=null">{{mPledge.status}}</td>
                            <td *ngIf="mPledge.status==null">-</td>
                            <td *ngIf="mPledge.registerDate!=null">{{mPledge.registerDate|date:'yyyy-MM-dd'}}</td>
                            <td *ngIf="mPledge.registerDate==null">-</td>
                          </tr>
                          <tbody *ngIf="mPledgeResult?.totalCount<1">
                          <tr>
                            <td colspan="7" style="text-align: center">暂无信息</td>
                          </tr>
                          </tbody>
                        </table>
                        <div [hidden]="mPledgeResult?.totalCount<10">
                          <app-page [totals]="mPledgeResult?.totalCount" [pageId]="'mPledgeId'"></app-page>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="archiveMod">
                    <h4 id="gqcz" class="gqcz">2.&nbsp;&nbsp;股权出质
                      <span class="totalClass" *ngIf="pledgeResult?.totalCount>0">（{{pledgeResult?.totalCount}}）</span>
                    </h4>
                    <div>
                      <div class="formBoxA">
                        <table cellpadding="0" cellspacing="0" border="0" width="100%" class="mar0A table2">
                          <tr>
                            <th width="7%">序号</th>
                            <th width="10%">登记编号</th>
                            <th width="10%">出质人</th>
                            <!--<th width="12%">证照/证件号码</th>-->
                            <th width="10%">出质股权数额</th>
                            <th width="18%">质权人</th>
                            <th width="12%">证照/证件号码</th>
                            <th width="14%">登记日期</th>
                            <th width="5%">状态</th>
                            <!--<th width="10%">公示日期</th>&lt;!&ndash;缺失&ndash;&gt;-->
                          </tr>
                          <tr *ngFor="let pledge of pledgeResult?.list;let i = index">
                            <td>{{(pledgeResult.page.pageNo-1)*pledgeResult.page.pageSize+i+1}}</td>
                            <td *ngIf="pledge.registNo!=null">{{pledge.registNo}}</td>
                            <td *ngIf="pledge.registNo==null">-</td>
                            <td *ngIf="pledge.pledgor!=null">{{pledge.pledgor}}</td>
                            <td *ngIf="pledge.pledgor==null">-</td>
                            <!--<td *ngIf="pledge.pledgorNo!=null">{{pledge.pledgorNo}}</td>-->
                            <!--<td *ngIf="pledge.pledgorNo==null">-</td>-->
                            <td *ngIf="pledge.pledgedAmount!=null">{{pledge.pledgedAmount}}</td>
                            <td *ngIf="pledge.pledgedAmount==null">-</td>
                            <td *ngIf="pledge.pledgee!=null">
                              <a style="color: #c9071d" (click)="openEnterprise(pledge.pledgee)">{{pledge.pledgee}}</a>
                            </td>
                            <td *ngIf="pledge.pledgee==null">-</td>
                            <td *ngIf="pledge.pledgeeNo!=null">{{pledge.pledgeeNo}}</td>
                            <td *ngIf="pledge.pledgeeNo==null">-</td>
                            <td *ngIf="pledge.regDate!=null">{{pledge.regDate|date:'yyyy-MM-dd'}}</td>
                            <td *ngIf="pledge.regDate==null">-</td>
                            <td *ngIf="pledge.status!=null">{{pledge.status}}</td>
                            <td *ngIf="pledge.status==null">-</td>
                            <!--<td *ngIf="pledge.regDate!=null">{{pledge.regDate|date:'yyyy-MM-dd'}}</td>-->
                            <td *ngIf="pledge.regDate==null">-</td>
                          </tr>
                          <tbody *ngIf="pledgeResult?.totalCount<1">
                          <tr>
                            <td colspan="10" style="text-align: center">暂无信息</td>
                          </tr>
                          </tbody>
                        </table>
                        <div [hidden]="pledgeResult?.totalCount<10">
                          <app-page [totals]="pledgeResult?.totalCount" [pageId]="'pledgeId'"></app-page>
                        </div>
                      </div>
                    </div>
                  </div>


                  <div class="archiveMod">
                    <h4 id="zscqcz" class="zscqcz">3.&nbsp;&nbsp;知识产权出质</h4>
                    <div>
                      <div class="formBoxA">
                        <table cellpadding="0" cellspacing="0" border="0" width="100%" class="mar0A table2">
                          <tr>
                            <th nowrap="nowrap" width="3%">序号</th>
                            <th nowrap="nowrap" width="11%">知识产权登记证号</th>
                            <th nowrap="nowrap" width="10%">名称</th>
                            <th nowrap="nowrap" width="8%">种类</th>
                            <th nowrap="nowrap" width="10%">出质人名称</th>
                            <th nowrap="nowrap" width="10%">质权人名称</th>
                            <th nowrap="nowrap" width="12%">质权登记期限</th>
                            <th nowrap="nowrap" width="7%">状态</th>
                            <th nowrap="nowrap" width="10%">公示日期</th><!--缺失-->
                            <th nowrap="nowrap" width="5%">详情</th>
                          </tr>
                          <!--<tr *ngFor="let opException of liqudationResult?.returnData;let i = index">-->
                          <!--<td>{{i+1}}</td>-->
                          <!--<td *ngIf="opException.addReason!=null">{{opException.addReason}}</td>-->
                          <!--<td *ngIf="opException.addReason==null">-</td>-->
                          <!--<td *ngIf="opException.addDate!=null">{{opException.addDate|date:'yyyy-MM-dd'}}</td>-->
                          <!--<td *ngIf="opException.addDate==null">-</td>-->
                          <!--<td *ngIf="opException.removeReason!=null">{{opException.removeReason}}</td>-->
                          <!--<td *ngIf="opException.removeReason==null">-</td>-->
                          <!--<td *ngIf="opException.removeDate!=null">{{opException.removeDate|date:'yyyy-MM-dd'}}</td>-->
                          <!--<td *ngIf="opException.removeDate==null">-</td>-->
                          <!--<td *ngIf="opException.decisionOffice!=null">{{opException.decisionOffice}}</td>-->
                          <!--<td *ngIf="opException.decisionOffice==null">-</td>-->
                          <!--</tr>-->
                          <tr>
                            <td colspan="10" style="text-align: center">暂无信息</td>
                          </tr>
                        </table>
                        <!--<div [hidden]="liqudationResult?.totalCount<10">-->
                        <!--<app-page [totals]="liqudationResult?.totalCount" [pageId]="'liqudationId'"></app-page>-->
                        <!--</div>-->
                      </div>
                    </div>
                  </div>


                  <div class="archiveMod">
                    <h4 id="qsxx" class="qsxx">4.&nbsp;&nbsp;清算信息</h4>
                    <div>
                      <div class="formBoxA">
                        <table cellpadding="0" cellspacing="0" border="0" width="100%" class="mar0A table2">
                          <tr>
                            <th width="7%">序号</th>
                            <th width="40%">清算组负责人</th>
                            <th width="53%">清算组成员</th>
                          </tr>
                          <tr *ngFor="let liquidation of liquidationResult?.list;let i = index">
                            <td>{{(liquidationResult.page.pageNo-1)*liquidationResult.page.pageSize+i+1}}</td>
                            <td *ngIf="liquidation.leader!=null">{{liquidation.leader}}</td>
                            <td *ngIf="liquidation.leader==null">-</td>
                            <td *ngIf="liquidation.member!=null">{{liquidation.member}}</td>
                            <td *ngIf="liquidation.member==null">-</td>
                          </tr>
                          <tbody *ngIf="liquidationResult?.totalCount<1">
                          <tr>
                            <td colspan="3" style="text-align: center">暂无信息</td>
                          </tr>
                          </tbody>
                        </table>
                        <div [hidden]="liquidationResult?.totalCount<10">
                          <app-page [totals]="liquidationResult?.totalCount" [pageId]="'liquidationId'"></app-page>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="archiveMod">
                    <h4 id="gsycml" class="gsycml">5.&nbsp;&nbsp;工商异常名录
                      <span class="totalClass" *ngIf="opExceptionResult?.totalCount>0">（{{opExceptionResult?.totalCount}}）</span>
                    </h4>
                    <div>
                      <div class="formBoxA">
                        <table cellpadding="0" cellspacing="0" border="0" width="100%" class="mar0A table2">
                          <tr>
                            <th nowrap="nowrap" width="3%">序号</th>
                            <th nowrap="nowrap" width="*">列入异常名录原因</th>
                            <th nowrap="nowrap" width="13%">列入日期</th>
                            <th nowrap="nowrap" width="25%">移出经营异常原因</th>
                            <th nowrap="nowrap" width="13%">移出日期</th>
                            <th nowrap="nowrap" width="21%">作出决定单位</th>
                          </tr>

                          <tr *ngFor="let opException of opExceptionResult?.list;let i = index">
                            <td>{{(opExceptionResult.page.pageNo-1)*opExceptionResult.page.pageSize+i+1}}</td>
                            <td *ngIf="opException.addReason!=null">{{opException.addReason}}</td>
                            <td *ngIf="opException.addReason==null">-</td>
                            <td *ngIf="opException.addDate!=null">{{opException.addDate|date:'yyyy-MM-dd'}}</td>
                            <td *ngIf="opException.addDate==null">-</td>
                            <td *ngIf="opException.romoveReason!=null">{{opException.romoveReason}}</td>
                            <td *ngIf="opException.romoveReason==null">-</td>
                            <td *ngIf="opException.removeDate!=null">{{opException.removeDate|date:'yyyy-MM-dd'}}</td>
                            <td *ngIf="opException.removeDate==null">-</td>
                            <td *ngIf="opException.decisionOffice!=null">{{opException.decisionOffice}}</td>
                            <td *ngIf="opException.decisionOffice==null">-</td>
                          </tr>
                          <tbody *ngIf="opExceptionResult?.totalCount<1">
                          <tr>
                            <td colspan="6" style="text-align: center">暂无信息</td>
                          </tr>
                          </tbody>
                        </table>
                        <div [hidden]="opExceptionResult?.totalCount<10">
                          <app-page [totals]="opExceptionResult?.totalCount" [pageId]="'opExceptionId'"></app-page>
                        </div>
                      </div>
                    </div>
                  </div>


                  <div class="archiveMod">
                    <h4 id="sfxx" class="sfxx">6.&nbsp;&nbsp;司法信息</h4>
                    <div>
                      <h5 class="marB20">6.1&nbsp;&nbsp;被执行人信息
                        <span class="totalClass"
                              *ngIf="executeResult?.totalCount>0">（{{executeResult?.totalCount}}）</span></h5>
                      <div class="formBoxA">
                        <table cellpadding="0" cellspacing="0" border="0" width="100%" class=" mar0A table2">
                          <tr>
                            <th nowrap="nowrap" width="3%">序号</th>
                            <th nowrap="nowrap" width="25%">案号</th>
                            <th nowrap="nowrap" width="*">执行法院</th>
                            <th nowrap="nowrap" width="25%">执行标的</th>
                            <th nowrap="nowrap" width="18%">立案时间</th>
                          </tr>
                          <tr *ngFor="let execute of executeResult?.list;let i = index">
                            <td>{{(executeResult.page.pageNo-1)*executeResult.page.pageSize+i+1}}</td>
                            <td *ngIf="execute.anNo!=null">{{execute.anNo}}</td>
                            <td *ngIf="execute.anNo==null">-</td>
                            <td *ngIf="execute.executeGov!=null">{{execute.executeGov}}</td>
                            <td *ngIf="execute.executeGov==null">-</td>
                            <td *ngIf="execute.biaoDi!=null">{{execute.biaoDi}}</td>
                            <td *ngIf="execute.biaoDi==null">-</td>
                            <td *ngIf="execute.liAnDate!=null">{{execute.liAnDate|date:'yyyy-MM-dd'}}</td>
                            <td *ngIf="execute.liAnDate==null">-</td>
                          </tr>
                          <tbody *ngIf="executeResult?.totalCount<1">
                          <tr>
                            <td colspan="5" style="text-align: center">暂无信息</td>
                          </tr>
                          </tbody>
                        </table>
                        <div [hidden]="executeResult?.totalCount<10">
                          <app-page [totals]="executeResult?.totalCount" [pageId]="'executeId'"></app-page>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="archiveMod">
                    <div>
                      <h5 class="marB20">6.2&nbsp;&nbsp;失信被执行人信息
                        <span class="totalClass" *ngIf="loseCreditExecuteResult?.totalCount>0">（{{loseCreditExecuteResult?.totalCount}}）</span>
                      </h5>
                      <div class="formBoxA">
                        <table cellpadding="0" cellspacing="0" border="0" width="100%" class=" mar0A table2">
                          <tr>
                            <th nowrap="nowrap" width="3%">序号</th>
                            <th nowrap="nowrap" width="16%">案件编号</th>
                            <th nowrap="nowrap" width="*">被执行人履行情况</th>
                            <th nowrap="nowrap" width="28%">法律文书确定的义务</th>
                            <th nowrap="nowrap" width="20%">执行法院</th>
                            <th nowrap="nowrap" width="13%">发布时间</th>
                          </tr>
                          <tr *ngFor="let loseCreditExecute of loseCreditExecuteResult?.list;let i = index">
                            <td>{{(loseCreditExecuteResult.page.pageNo-1)*loseCreditExecuteResult.page.pageSize+i+1}}
                            </td>
                            <td *ngIf="loseCreditExecute.anNo!=null">{{loseCreditExecute.anNo}}</td>
                            <td *ngIf="loseCreditExecute.anNo==null">-</td>
                            <td *ngIf="loseCreditExecute.executeStatus!=null">{{loseCreditExecute.executeStatus}}</td>
                            <td *ngIf="loseCreditExecute.executeStatus==null">-</td>
                            <td *ngIf="loseCreditExecute.yiWu!=null">{{loseCreditExecute.yiWu}}</td>
                            <td *ngIf="loseCreditExecute.yiWu==null">-</td>
                            <td *ngIf="loseCreditExecute.executeUnit!=null">{{loseCreditExecute.executeUnit}}</td>
                            <td *ngIf="loseCreditExecute.executeUnit==null">-</td>
                            <td *ngIf="loseCreditExecute.publicDate!=null">
                              {{loseCreditExecute.publicDate|date:'yyyy-MM-dd'}}
                            </td>
                            <td *ngIf="loseCreditExecute.publicDate==null">-</td>
                          </tr>
                          <tbody *ngIf="loseCreditExecuteResult?.totalCount<1">
                          <tr>
                            <td colspan="6" style="text-align: center">暂无信息</td>
                          </tr>
                          </tbody>
                        </table>
                        <div [hidden]="loseCreditExecuteResult?.totalCount<10">
                          <app-page [totals]="loseCreditExecuteResult?.totalCount"
                                    [pageId]="'loseCreditExecuteId'"></app-page>
                        </div>
                      </div>
                    </div>
                  </div>


                  <div class="archiveMod">
                    <div>
                      <h5 class="marB20">6.3&nbsp;&nbsp;裁判文书信息
                        <span class="totalClass" *ngIf="caseResult?.totalCount>0">（{{caseResult?.totalCount}}）</span>
                      </h5>
                      <div class="formBoxA">
                        <table cellpadding="0" cellspacing="0" border="0" width="100%" class=" mar0A table2">
                          <tr>
                            <th nowrap="nowrap" width="3%">序号</th>
                            <th nowrap="nowrap" width="25%">文书编号</th>
                            <th nowrap="nowrap" width="*">标题</th>
                            <th nowrap="nowrap" width="18%">类型</th>
                            <th nowrap="nowrap" width="25%">执行法院</th>
                          </tr>
                          <tr *ngFor="let caseB of caseResult?.list;let i = index">
                            <td>{{(caseResult.page.pageNo-1)*caseResult.page.pageSize+i+1}}</td>
                            <td *ngIf="caseB.caseNo!=null">{{caseB.caseNo}}</td>
                            <td *ngIf="caseB.caseNo==null">-</td>
                            <td *ngIf="caseB.caseName!=null">{{caseB.caseName}}</td>
                            <td *ngIf="caseB.caseName==null">-</td>
                            <td *ngIf="caseB.caseType=='ms'">民事案件</td>
                            <td *ngIf="caseB.caseType=='zx'">执行案件</td>
                            <td *ngIf="caseB.caseType=='xz'">行政案件</td>
                            <td *ngIf="caseB.caseType=='zscq'">知识产权案件</td>
                            <td
                              *ngIf="caseB.caseType!='ms' && caseB.caseType!='zx' && caseB.caseType!='xz' && caseB.caseType!='zscq'">
                              其他
                            </td>
                            <td *ngIf="caseB.court!=null">{{caseB.court}}</td>
                            <td *ngIf="caseB.court==null">-</td>
                          </tr>
                          <tbody *ngIf="caseResult?.totalCount<1">
                          <tr>
                            <td colspan="5" style="text-align: center">暂无信息</td>
                          </tr>
                          </tbody>
                        </table>
                        <div [hidden]="caseResult?.totalCount<10">
                          <app-page [totals]="caseResult?.totalCount" [pageId]="'caseBExecuteId'"></app-page>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="archiveMod">
                    <h5 class="marB20">6.4&nbsp;&nbsp;法院公告信息
                      <span class="totalClass"
                            *ngIf="chinacourtResult?.totalCount>0">（{{chinacourtResult?.totalCount}}）</span></h5>
                    <div>
                      <div class="formBoxA">
                        <table cellpadding="0" cellspacing="0" border="0" width="100%" class="mar0A table2">
                          <tr>
                            <th nowrap="nowrap" width="3%">序号</th>
                            <th nowrap="nowrap" width="14%">公示时间</th>
                            <th nowrap="nowrap" width="16%">分类</th>
                            <th nowrap="nowrap" width="20%">当事人</th>
                            <th nowrap="nowrap" width="47%">公告内容</th>
                          </tr>

                          <tr *ngFor="let chinacourt of chinacourtResult?.list;let i = index">
                            <td>{{(chinacourtResult.page.pageNo-1)*chinacourtResult.page.pageSize+i+1}}</td>
                            <td *ngIf="chinacourt.publicDate!=null">{{chinacourt.publicDate|date:'yyyy-MM-dd'}}</td>
                            <td *ngIf="chinacourt.publicDate==null">-</td>
                            <td *ngIf="chinacourt.catagory!=null">{{chinacourt.catagory}}</td>
                            <td *ngIf="chinacourt.catagory==null">-</td>
                            <td *ngIf="chinacourt.litigant!=null && chinacourt.isCompany">
                              <a style="color: #c9071d" (click)="openEnterprise(chinacourt.litigant)">{{chinacourt.litigant}}</a>
                            </td>
                            <td *ngIf="chinacourt.litigant!=null && !chinacourt.isCompany">
                              {{chinacourt.litigant}}
                            </td>
                            <td *ngIf="chinacourt.litigant==null">-</td>
                            <td *ngIf="chinacourt.content!=null">{{chinacourt.content}}</td>
                            <td *ngIf="chinacourt.content==null">-</td>
                          </tr>
                          <tbody *ngIf="chinacourtResult?.totalCount<1">
                          <tr>
                            <td colspan="5" style="text-align: center">暂无信息</td>
                          </tr>
                          </tbody>
                        </table>
                        <div [hidden]="chinacourtResult?.totalCount<10">
                          <app-page [totals]="chinacourtResult?.totalCount" [pageId]="'chinacourtId'"></app-page>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="archiveMod">
                    <h4 id="choucha" class="choucha">7.&nbsp;&nbsp;抽查信息
                      <span class="totalClass"
                            *ngIf="spotcheckResult?.totalCount>0">（{{spotcheckResult?.totalCount}}）</span></h4>
                    <div>
                      <div class="formBoxA">
                        <table cellpadding="0" cellspacing="0" border="0" width="100%" class="mar0A table2">
                          <tr>
                            <th nowrap="nowrap" width="3%">序号</th>
                            <th nowrap="nowrap" width="*">检察实施机关</th>
                            <th nowrap="nowrap" width="20%">类型</th>
                            <th nowrap="nowrap" width="15%">日期</th>
                          </tr>

                          <tr *ngFor="let spotcheck of spotcheckResult?.list;let i = index">
                            <td>{{(spotcheckResult.page.pageNo-1)*spotcheckResult.page.pageSize+i+1}}</td>
                            <td *ngIf="spotcheck.executiveOrg!=null">{{spotcheck.executiveOrg}}</td>
                            <td *ngIf="spotcheck.executiveOrg==null">-</td>
                            <td *ngIf="spotcheck.type!=null">{{spotcheck.type}}</td>
                            <td *ngIf="spotcheck.type==null">-</td>
                            <td *ngIf="spotcheck.date!=null && spotcheck.date != '0001-01-01'">{{spotcheck.date|date:'yyyy-MM-dd'}}</td>
                            <td *ngIf="spotcheck.date==null || spotcheck.date == '0001-01-01'">-</td>
                          </tr>
                          <tbody *ngIf="spotcheckResult?.totalCount<1">
                          <tr>
                            <td colspan="6" style="text-align: center">暂无信息</td>
                          </tr>
                          </tbody>
                        </table>
                        <div [hidden]="spotcheckResult?.totalCount<10">
                          <app-page [totals]="spotcheckResult?.totalCount" [pageId]="'spotcheckId'"></app-page>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="archiveMod">
                    <h4 id="xzcf" class="xzcf">8.&nbsp;&nbsp;行政处罚信息
                      <span class="totalClass"
                            *ngIf="penaltyResult?.totalCount>0">（{{penaltyResult?.totalCount}}）</span></h4>
                    <div>
                      <div class="formBoxA">
                        <table cellpadding="0" cellspacing="0" border="0" width="100%" class="mar0A table2">
                          <tr>
                            <th nowrap="nowrap" width="3%">序号</th>
                            <th nowrap="nowrap" width="20%">决定文书号</th>
                            <th nowrap="nowrap" width="20%">违法行为类型</th>
                            <th nowrap="nowrap" width="*">行政处罚内容</th>
                            <th nowrap="nowrap" width="15%">决定单位</th>
                            <th nowrap="nowrap" width="15%">决定日期</th>
                          </tr>

                          <tr *ngFor="let penalty of penaltyResult?.list;let i = index">
                            <td>{{(penaltyResult.page.pageNo-1)*penaltyResult.page.pageSize+i+1}}</td>
                            <td *ngIf="penalty.docNo!=null">{{penalty.docNo}}</td>
                            <td *ngIf="penalty.docNo==null">-</td>
                            <td *ngIf="penalty.penaltyType!=null">{{penalty.penaltyType}}</td>
                            <td *ngIf="penalty.penaltyType==null">-</td>
                            <td *ngIf="penalty.content!=null">{{penalty.content}}</td>
                            <td *ngIf="penalty.content==null">-</td>
                            <td *ngIf="penalty.officeName!=null">{{penalty.officeName}}</td>
                            <td *ngIf="penalty.officeName==null">-</td>
                            <td *ngIf="penalty.penaltyDate!=null && penalty.penaltyDate != '0001-01-01'">{{penalty.penaltyDate|date:'yyyy-MM-dd'}}</td>
                            <td *ngIf="penalty.penaltyDate==null || penalty.penaltyDate == '0001-01-01'">-</td>
                          </tr>
                          <tbody *ngIf="penaltyResult?.totalCount<1">
                          <tr>
                            <td colspan="6" style="text-align: center">暂无信息</td>
                          </tr>
                          </tbody>
                        </table>
                        <div [hidden]="penaltyResult?.totalCount<10">
                          <app-page [totals]="penaltyResult?.totalCount" [pageId]="'penaltyId'"></app-page>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="archiveMod">
                    <h3 id="yqhqtgkxx" class="yqhqtgkxx"><span class="floatL">三、舆情和其他公开信息</span><span
                      class="floatR"></span></h3>
                    <h4 id="qyyqxx" class="qyyqxx">1.&nbsp;&nbsp;企业舆情信息
                      <span class="totalClass"
                            *ngIf="newsInfoResult?.totalCount>0">（{{newsInfoResult?.totalCount}}）</span></h4>
                    <div>
                      <div class="formBoxA">
                        <table cellpadding="0" cellspacing="0" border="0" width="100%" class="mar0A table2">
                          <tr>
                            <th nowrap="nowrap" width="3%">序号</th>
                            <th nowrap="nowrap" width="46%">舆情标题</th>
                            <th nowrap="nowrap" width="18%">发生日期</th>
                            <th nowrap="nowrap" width="29%">转载网站</th>
                          </tr>
                          <tr *ngFor="let newsInfo of newsInfoResult?.list;let i = index">
                            <td>{{(newsInfoResult.page.pageNo-1)*newsInfoResult.page.pageSize+i+1}}</td>
                            <td *ngIf="newsInfo.title!=null">{{newsInfo.title}}</td>
                            <td *ngIf="newsInfo.title==null">-</td>
                            <td *ngIf="newsInfo.publishTime!=null">{{newsInfo.publishTime|date:'yyyy-MM-dd'}}</td>
                            <td *ngIf="newsInfo.publishTime==null">-</td>
                            <td *ngIf="newsInfo.source!=null"><a style="color: #c9071d" href="{{newsInfo.url}}"
                                                                 target="_blank">{{newsInfo.source}}</a></td>
                            <td *ngIf="newsInfo.source==null">-</td>
                          </tr>
                          <tbody *ngIf="newsInfoResult?.totalCount<1">
                          <tr>

                            <td colspan="4" style="text-align: center">暂无信息</td>
                          </tr>
                          </tbody>
                        </table>
                        <div [hidden]="newsInfoResult?.totalCount<10">
                          <app-page [totals]="newsInfoResult?.totalCount" [pageId]="'newsInfoId'"></app-page>
                        </div>
                      </div>
                    </div>
                  </div>


                  <div class="archiveMod">
                    <h4 id="ztbxx" class="ztbxx">2.&nbsp;&nbsp;招投标信息
                      <span class="totalClass" *ngIf="operationTenderResult?.totalCount>0">（{{operationTenderResult?.totalCount}}）</span>
                    </h4>
                    <div>
                      <div class="formBoxA">
                        <table cellpadding="0" cellspacing="0" border="0" width="100%" class="mar0A table2">
                          <tr>
                            <th width="7%">序号</th>
                            <th width="55%">描述</th>
                            <th width="15%">发布时间</th>
                            <th width="15%">所属地区</th>
                            <th width="15%">项目分类</th>
                          </tr>
                          <tr *ngFor="let operationTender of operationTenderResult?.list;let i = index">
                            <td>{{(operationTenderResult.page.pageNo-1)*operationTenderResult.page.pageSize+i+1}}</td>
                            <td *ngIf="operationTender.title!=null">{{operationTender.title}}</td>
                            <td *ngIf="operationTender.title==null">-</td>
                            <td *ngIf="operationTender.publishTime!=null">
                              {{operationTender.publishTime|date:'yyyy-MM-dd'}}
                            </td>
                            <td *ngIf="operationTender.publishTime==null">-</td>
                            <td *ngIf="operationTender.provinceName!=null">{{operationTender.provinceName}}</td>
                            <td *ngIf="operationTender.provinceName==null">-</td>
                            <td *ngIf="operationTender.channelName!=null">{{operationTender.channelName}}</td>
                            <td *ngIf="operationTender.channelName==null">-</td>
                          </tr>
                          <tbody *ngIf="operationTenderResult?.totalCount<1 || !isFromQi">
                          <tr>

                            <td colspan="5" style="text-align: center">暂无信息</td>
                          </tr>
                          </tbody>
                        </table>
                        <div [hidden]="operationTenderResult?.totalCount<10 || !isFromQi">
                          <app-page [totals]="operationTenderResult?.totalCount"
                                    [pageId]="'operationTenderId'"></app-page>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="archiveMod">
                    <h4 id="zplxx" class="zplxx">3.&nbsp;&nbsp;招聘类信息
                      <span class="totalClass" *ngIf="recruitInfoResult?.totalCount>0">（{{recruitInfoResult?.totalCount}}）</span>
                    </h4>
                    <div>
                      <div class="formBoxA">
                        <table cellpadding="0" cellspacing="0" border="0" width="100%" class="mar0A table2">
                          <tr>
                            <th nowrap="nowrap" width="3%">序号</th>
                            <th nowrap="nowrap" width="13%">职位名称</th>
                            <th nowrap="nowrap" width="3%">地区</th>
                            <th nowrap="nowrap" width="3%">薪资</th>
                            <th nowrap="nowrap" width="5%">学历</th>
                            <th nowrap="nowrap" width="7%">工作经验</th>
                            <th nowrap="nowrap" width="41%">工作内容（职位要求）</th>
                            <th nowrap="nowrap" width="15%">发布日期</th>
                            <th nowrap="nowrap" width="10%">数据来源</th>
                          </tr>
                          <tr *ngFor="let recruitInfo of recruitInfoResult?.list;let i = index">
                            <td>{{(recruitInfoResult.page.pageNo-1)*recruitInfoResult.page.pageSize+i+1}}</td>
                            <td *ngIf="recruitInfo.title!=null">{{recruitInfo.title}}</td>
                            <td *ngIf="recruitInfo.title==null">-</td>
                            <td *ngIf="recruitInfo.area!=null">{{recruitInfo.area}}</td>
                            <td *ngIf="recruitInfo.area==null">-</td>
                            <td *ngIf="recruitInfo.salary!=null">{{recruitInfo.salary}}</td>
                            <td *ngIf="recruitInfo.salary==null">-</td>
                            <td *ngIf="recruitInfo.education!=null">{{recruitInfo.education}}</td>
                            <td *ngIf="recruitInfo.education==null">-</td>
                            <td *ngIf="recruitInfo.experience!=null">{{recruitInfo.experience}}</td>
                            <td *ngIf="recruitInfo.experience==null">-</td>
                            <td *ngIf="recruitInfo.description!=null">{{recruitInfo.description}}</td>
                            <td *ngIf="recruitInfo.description==null">-</td>
                            <td *ngIf="recruitInfo.publishTime!=null">{{recruitInfo.publishTime|date:'yyyy-MM-dd'}}</td>
                            <td *ngIf="recruitInfo.publishTime==null">-</td>
                            <td *ngIf="recruitInfo.source!=null">{{recruitInfo.source}}</td>
                            <td *ngIf="recruitInfo.source==null">-</td>
                          </tr>
                          <tbody *ngIf="recruitInfoResult?.totalCount<1">
                          <tr>
                            <td colspan="9" style="text-align: center">暂无信息</td>
                          </tr>
                          </tbody>
                        </table>
                        <div [hidden]="recruitInfoResult?.totalCount<10">
                          <app-page [totals]="recruitInfoResult?.totalCount" [pageId]="'recruitInfoId'"></app-page>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


    </div>
    <div class="push">
      <!--请浮动勿删-->
    </div>
  </div>
</div>

<div [hidden]="!_isSpinning" style="position: fixed;left: 0;right: 0;top: 0;bottom: 0;z-index: 11;">
  <div style="position: fixed; top: 50%; left: 50%;">
    <nz-spin [nzSize]="'large'" [nzSpinning]="_isSpinning" [nzTip]="'报告下载中...'"></nz-spin>
  </div>
</div>


<div id="enterMap" style="width: 900px; height: 900px; position: absolute; top: 0;" ></div>
<img id="testImage">



// WEBPACK FOOTER //
// E:/java/gd-project/credit-gd-web/src/app/components/enterp-basic-archives/enterp-basic-archives.component.html